import * as React from 'react';
import { Input as InputPrimitive } from '@base-ui/react/input';

import { cn } from '@/lib/utils';
import { controlFocus } from '@/lib/controlStyles';

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithoutRef<'input'>
>(({ className, type, ...props }, ref) => {
  return (
    <InputPrimitive
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        'tw:flex tw:h-9 tw:w-full tw:min-w-0 tw:rounded-lg tw:border tw:border-input tw:bg-transparent tw:px-3 tw:py-1 tw:text-sm tw:text-foreground tw:shadow-xs tw:transition-[color,box-shadow] tw:file:inline-flex tw:file:h-7 tw:file:cursor-pointer tw:file:border-0 tw:file:bg-transparent tw:file:text-sm tw:file:font-medium tw:file:text-foreground tw:[&[type=file]:not([aria-invalid])]:text-muted-foreground tw:[&[type=file]]:cursor-pointer tw:placeholder:text-muted-foreground tw:hover:border-ring tw:disabled:bg-muted tw:disabled:opacity-50 tw:aria-invalid:border-destructive tw:aria-invalid:text-destructive tw:dark:aria-invalid:border-destructive/50',
        controlFocus,
        className
      )}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
